import React, { useState } from 'react';
import './OfferSection.css';
import downloadImage from '../assets/images/downloadwork.png';
import iconMassage from '../assets/images/klangschalen.png';
import iconEnergy from '../assets/images/energiearbeit.png';
import iconNLP from '../assets/images/nlp3.png';
import iconTarot from '../assets/images/tarot.png';
import iconMentoring from '../assets/images/mentoring.png';

const offers = [
  {
    title: "Klangschalenmassage",
    short: "77 € (60 Minuten inkl. Vor- & Nachbereitung)",
    icon: iconMassage,
    details: `Tauche ein in die heilsamen Schwingungen der Klangschalen und spüre, wie sich dein Körper, Geist und Energiesystem ganz natürlich harmonisieren.

Die feinen Vibrationen durchdringen jede Zelle, lösen Spannungen und bringen dich in einen tiefen Zustand der Entspannung – ohne dass du etwas tun musst.

Diese Session ist ideal bei Erschöpfung, innerer Unruhe, Schlafproblemen oder emotionaler Überforderung.

Ein Geschenk an dich selbst – für mehr Ruhe, Klarheit und Verbindung mit deiner inneren Mitte.`,
  },
  {
    title: "Power-Session",
    short: "122 € (2 Stunden)",
    icon: iconNLP,
    details: `In dir steckt so viel mehr, als du im Alltag spürst.

Diese Power-Session aktiviert deine innere Kraft durch intuitives Coaching, emotionale Prozessarbeit und energetische Aktivierung.

Perfekt, wenn du bereit bist, über dich hinauszuwachsen und nicht mehr nur zu funktionieren.`,
  },
  {
    title: "Magnified Healing",
    short: "88 € (ca. 60 Minuten, auch online möglich)",
    icon: iconEnergy,
    details: `Eine hochschwingende Energieheilung, die dein Energiesystem auf feinstofflicher Ebene reinigt, klärt und neu ausrichtet.

Emotionale Altlasten, karmische Themen oder tiefe Spannungen dürfen sich lösen – auch als Fernbehandlung kraftvoll spürbar.`,
  },
  {
    title: "Kartenlegung & Numerologie-Reading",
    short: "50 € (Online)",
    icon: iconTarot,
    details: `In diesem Reading verbinden sich Kartenlegen und Numerologie zu einer tiefen Analyse deines Weges.

Du erhältst intuitive Impulse und klare Hinweise für deinen nächsten Schritt – spirituell, aber bodenständig.`,
  },
  {
    title: "1:1 Intensiv-Mentoring",
    short: "Auf Anfrage (6 Wochen All-Inclusive)",
    icon: iconMentoring,
    details: `Für Frauen, die bereit sind, sich selbst auf einer neuen Ebene zu begegnen.

Intensive Begleitung mit exklusiven Sessions, energetischer Heilarbeit und kontinuierlichem Support – für deine emotionale Freiheit und innere Stärke.`,
  },
];

const OfferSection = () => {
  const [selectedOffer, setSelectedOffer] = useState(null);

  const handleOpen = (offer) => setSelectedOffer(offer);
  const handleClose = () => setSelectedOffer(null);

  return (
    <section className="offer-section">
      <h2 className="offer-title">Mein Angebot</h2>

      <div className="offer-table">
        {offers.map((offer, index) => (
          <div key={index} className="offer-row">
            <div className="offer-icon-container">
              <img src={offer.icon} alt={offer.title} className="offer-icon" />
            </div>
            <div className="offer-content">
              <span className="offer-title-bold">{offer.title}</span>
              <p className="offer-description">{offer.short}</p>
              <button className="offer-button" onClick={() => handleOpen(offer)}>Mehr erfahren</button>
            </div>
          </div>
        ))}
      </div>

      <div className="download-container">
        <div className="download-content">
          <p className="download-text">
            Lade dir jetzt mein kostenloses Workbook als PDF herunter!
          </p>
          <a
            href="https://myablefy.com/s/chiarakoerner/mission-emotion-das-woorkbook-zur-emotionalen-selbstfuehrung-936bb806"
            className="download-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            PDF Download
          </a>
        </div>
        <img src={downloadImage} alt="Download" className="download-image" />
      </div>

      {selectedOffer && (
        <div className="modal-overlay" onClick={handleClose}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3>{selectedOffer.title}</h3>
            <p>{selectedOffer.details}</p>
            <button className="offer-button" onClick={handleClose}>Schließen</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default OfferSection;
